import { InputHTMLAttributes, ReactNode, forwardRef } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    label?: ReactNode;
    error?: boolean;
    helperText?: ReactNode;
    startIcon?: ReactNode;
    endIcon?: ReactNode;
}

/**
 * Champ de saisie standardisé — remplace MUI TextField (variant simple).
 * Compatible avec react-hook-form via ref forwarding.
 */
const Input = forwardRef<HTMLInputElement, InputProps>(
    ({ label, error, helperText, startIcon, endIcon, className = '', ...rest }, ref) => (
        <div className="w-full">
            {label && (
                <label className="block text-xs font-semibold text-[var(--eb-text-muted)] mb-1.5">
                    {label}
                </label>
            )}
            <div className="relative">
                {startIcon && (
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--eb-text-muted)] pointer-events-none">
                        {startIcon}
                    </span>
                )}
                <input
                    ref={ref}
                    className={`w-full px-3 py-2 text-sm rounded-lg border bg-[var(--eb-surface)] text-[var(--eb-text)]
                        placeholder:text-[var(--eb-text-muted)]/60
                        focus:outline-none focus:ring-2 focus:ring-[var(--eb-primary)]/40 focus:border-[var(--eb-primary)]
                        transition-colors duration-150
                        disabled:opacity-50 disabled:cursor-not-allowed
                        ${error ? 'border-red-500 focus:ring-red-500/40 focus:border-red-500' : 'border-[var(--eb-border)]'}
                        ${startIcon ? 'pl-9' : ''} ${endIcon ? 'pr-9' : ''} ${className}`}
                    {...rest}
                />
                {endIcon && (
                    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[var(--eb-text-muted)]">
                        {endIcon}
                    </span>
                )}
            </div>
            {helperText && (
                <p className={`mt-1 text-xs ${error ? 'text-red-500' : 'text-[var(--eb-text-muted)]'}`}>
                    {helperText}
                </p>
            )}
        </div>
    )
);

Input.displayName = 'Input';
export default Input;
